<sbe-app-shell-root
  [infraError]="auth.infraError()"
  [showBootLoading]="showBootLoading()"
  [shellBare]="shellRouteData().shellBare"
  [header]="shellRouteData().shellMode"
  [navItems]="navItems()"
  homeRoute="/dashboard"
  [loggedIn]="auth.isAuthenticated()"
  (retry)="retry()"
>
  <!--
    슬롯 하나당 @if 하나씩 — 같은 @if 블록에 서로 다른 슬롯 셀렉터를 가진 root 노드를
    여러 개 두면 Angular가 어느 슬롯에도 투영하지 못한다(NG8011, "여러 개의 root 노드").
  -->
  @if (showToolbarChrome()) {
    <spinoff-org-switcher
      shellToolbarContext
      [activeOrgId]="activeContext.orgId()"
      [personalContextEnabled]="false"
      (orgSelected)="onOrgSelected($event)"
      (invitationsRequested)="onInvitationsRequested()"
    />
  }
  @if (showToolbarChrome()) {
    <spinoff-notification-bell shellToolbarActions viewAllRoute="/notifications" />
  }
  @if (showToolbarChrome()) {
    <spinoff-profile-menu shellToolbarEnd (logoutRequested)="logout()" />
  } @else if (showLoginButton() && loginCta().external) {
    <a mat-flat-button color="primary" shellToolbarEnd [href]="loginCta().href">로그인</a>
  } @else if (showLoginButton()) {
    <a mat-flat-button color="primary" shellToolbarEnd [routerLink]="loginCta().href">로그인</a>
  }
</sbe-app-shell-root>
